import Api from "./Api";

export default {
    async index(form) {
        return Api.get("/packages", {
            params: form
        });
    },

    async store(form, id) {
        if (id)
            return Api.post("/packages/" + id, form);

        return Api.post("/packages", form);
    },

    async show(id) {
        return Api.post("/packages/" + id);
    },

    async update(form, id) {
        form.append("_method", "PATCH");
        return Api.post("/packages/" + id, form);
    },

    async delete(id) {
        return Api.delete("/packages/" + id);
    },

};
